import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Form, Select } from '@arco-design/web-react';

import { isFieldInteractionLocked } from '../../platform/capability-registry/fieldControl';
import { isFieldVisible } from '../../platform/capability-registry/resolveFieldMode';
import { POWER_POLICY_FIELD_KEYS } from './fieldKeys';
import { useInstanceConfig } from './hooks';
import type { PowerPolicyBlockProps, PowerPolicyPaths } from './types';

const FormItem = Form.Item;

export function PowerPolicyBlock(props: PowerPolicyBlockProps) {
  const { paths: rawPaths, options, ...control } = props;
  const paths = rawPaths as PowerPolicyPaths;
  const { t } = useTranslation();
  const config = useInstanceConfig();

  const showLabel = options?.showLabel !== false;
  const locked = isFieldInteractionLocked(POWER_POLICY_FIELD_KEYS.powerPolicy, control);
  const isPreview = control.blockMode === 'preview';

  const policies = useMemo(() => {
    return config?.powerPolicies || [];
  }, [config]);

  if (!isFieldVisible(POWER_POLICY_FIELD_KEYS.powerPolicy, control)) {
    return null;
  }

  return (
    <FormItem
      label={showLabel ? t('common:power.policy') : undefined}
      field={paths.powerPolicy}
      rules={isPreview ? undefined : [{ required: true, message: t('common:required') }]}
      disabled={locked}
    >
      <Select showSearch placeholder={t('data-center:please.select.the.power.policy')} disabled={locked}>
        {policies?.map((i) => (
          <Select.Option key={i.key} value={i.key}>
            <span>{i.key}</span>
            {i?.description && <span style={{ marginLeft: 32, fontSize: '12px', color: 'rgba(0,0,0,0.3)' }}>{i.description}</span>}
          </Select.Option>
        ))}
      </Select>
    </FormItem>
  );
}

export function PowerPolicyItem({ field = 'powerPolicy', showLabel = true }) {
  const { t } = useTranslation();
  const config = useInstanceConfig();

  const policies = useMemo(() => {
    return config?.powerPolicies || [];
  }, [config]);

  return (
    <FormItem
      label={showLabel ? t('common:power.policy') : undefined}
      field={field}
      rules={[{ required: true, message: t('common:required') }]}
    >
      <Select showSearch placeholder={t('data-center:please.select.the.power.policy')}>
        {policies?.map((i) => (
          <Select.Option key={i.key} value={i.key}>
            <span>{i.key}</span>
            <span style={{ marginLeft: 32, fontSize: '12px', color: 'rgba(0,0,0,0.3)' }}>{i?.description}</span>
          </Select.Option>
        ))}
      </Select>
    </FormItem>
  );
}
